import axios from 'axios';
import { Modal } from 'antd';
import { createSecureHeaders } from './tokenUtils';

const apiClient = axios.create({
  baseURL: 'https://apivoicengoai.taothaoai.com', // Đặt baseURL mặc định, có thể override bằng axios.defaults.baseURL
  timeout: 30000,
});

// Tránh hiện modal nhiều lần cùng lúc
let planExpiredModalShown = false;

function showPlanExpiredModal() {
  if (planExpiredModalShown) return;
  planExpiredModalShown = true;

  Modal.confirm({
    title: 'Gói sử dụng đã hết hạn',
    content: (
      <div style={{ lineHeight: '1.8', marginTop: 8 }}>
        <p style={{ marginBottom: 8 }}>
          Tài khoản của bạn đã <strong>hết hạn sử dụng dịch vụ</strong>.
          Bạn sẽ không thể thực hiện tổng hợp giọng nói cho đến khi gia hạn.
        </p>
        <p style={{ color: '#888', fontSize: 13, marginBottom: 0 }}>
          Vui lòng chọn gói phù hợp hoặc liên hệ admin để được hỗ trợ.
        </p>
      </div>
    ),
    okText: '🚀 Xem gói dịch vụ',
    cancelText: 'Đóng',
    okButtonProps: { type: 'primary' },
    onOk: () => {
      planExpiredModalShown = false;
      window.location.href = '/pricing';
    },
    onCancel: () => {
      planExpiredModalShown = false;
    },
  });
}

// Request interceptor — gắn Authorization + X-Security-Token
apiClient.interceptors.request.use(
  (config) => {
    const state = store?.getState();
    const user = state?.auth?.user;

    if (user && user.id) {
      const secureHeaders = createSecureHeaders(user.id);
      const existingAuth =
        axios.defaults.headers.common['Authorization'] ||
        (localStorage.getItem('access_token')
          ? `Bearer ${localStorage.getItem('access_token')}`
          : null);

      config.headers = {
        ...config.headers,
        ...secureHeaders,
        ...(existingAuth && { Authorization: existingAuth }),
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — xử lý lỗi
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const serverMsg = error.response?.data?.message || '';

    if (status === 403) {
      if (serverMsg.toLowerCase().includes('admin')) {
        // Không có quyền admin — không cần modal, để component tự xử lý
      } else {
        // Plan hết hạn hoặc bị khoá
        showPlanExpiredModal();
      }
    } else if (status === 401) {
      console.warn('API: token không hợp lệ hoặc đã hết hạn');
    }

    return Promise.reject(error);
  }
);

let store;
export const setStore = (reduxStore) => {
  store = reduxStore;
};

export default apiClient;
